import { render, staticRenderFns } from "./BrandCreator.vue?vue&type=template&id=90330946&scoped=true&"
import script from "./BrandCreator.vue?vue&type=script&lang=js&"
export * from "./BrandCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90330946",
  null
  
)

export default component.exports